// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1mwz3","paramInput":"JobSimulator_paramInput__SAm-V","input":"JobSimulator_input__1YlYm"};